
import { Delete, InfoOutlined } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import { useEffect, useState } from 'react'
function DayTypeDialog({ open, onClose, isHoliday, isClosingDay, date, onSave }) {
    const { t } = useTranslation();

    const dateString = date.toLocaleDateString(i18n.language === 'de' ? 'de' : 'en-US', {
        weekday: 'long',
        day: '2-digit',
        date: '2-digit',
        month: 'long',
        year: 'numeric'
    });

    const [value, setValue] = useState('common');

    useEffect(() => {
        if (isHoliday) {
            setValue('holiday');
        } else if (isClosingDay) {
            setValue('closingDay');
        }
        else {
            setValue('common');
        };
    }, [isHoliday, isClosingDay]);


    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>
                <Trans i18nKey={'tagÄndern'} ns={'instituteConfigurationPage'}>{dateString}</Trans>
                <Typography sx={{ mt: 1 }} variant='subtitle2'>
                    {t('typBeschreibung', { ns: 'instituteConfigurationPage', defaultValue: 'Lege fest, ob es sich um einen Feiertag oder Brückentag handelt' })}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <FormControl>
                    <FormLabel>Typ</FormLabel>
                    <RadioGroup
                        defaultValue={isHoliday ? 'holiday' : isClosingDay ? 'closingDay' : 'common'}
                        onChange={(e) => setValue(e.target.value)}
                    >
                        <FormControlLabel value="holiday" control={<Radio />} label={t('feiertag', { ns: 'timeKeepingPage', defaultValue: 'Feiertag' })} />
                        <FormControlLabel value="closingDay" control={<Radio />} label={t('brückentag', { ns: 'timeKeepingPage', defaultValue: 'Brückentag' })} />
                        <FormControlLabel value="common" control={<Radio />} label={t('gewöhnlich', { ns: 'timeKeepingPage', defaultValue: 'Gewöhnlich' })} />
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button variant='contained' onClick={() => {
                    onSave(value);
                    onClose();
                }}>Speichern</Button>
            </DialogActions>
        </Dialog >
    );
};

export default DayTypeDialog
